import * as React from 'react';
import './App.css';

import { FireInput } from './components/Items/FireInput';
class App extends React.Component {
  public render() {
    return (
      <div className="App">
        <header className="App-header">
          <h1 className="App-title">Comment boxes</h1>
        </header>
        <br/>
        <FireInput private={true} />
        <br/>
        <br/>
        <FireInput private={false} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx